import { render } from "./OptionPage.vue?vue&type=template&id=09b010a0"
import script from "./OptionPage.vue?vue&type=script&lang=js"
export * from "./OptionPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__